import { IUser } from 'src/utils/interfaces/user';
import { PaymentDataResponse } from 'src/services/models/payment.service';
import TooltipIcon from 'src/components/ui/tooltip';
import { useLocalization } from 'src/utils/useLocalization';
import { useSelector } from 'react-redux';
import './styles.scss';
interface IProps {
    data: PaymentDataResponse;
    isQuoteDetail?: boolean;
}

const ViewInformation = ({ data, isQuoteDetail = false }: IProps) => {
    const { payments, paymentAccountEnumToUi } = useLocalization();
    const dealerDataInfo = useSelector((state: IUser) => {
        return state.dealerDataInfo;
    });
    function getCity(paymentData: PaymentDataResponse) {
        const city = paymentData.accountDetail.address.City ?? '';
        const zipCode = paymentData.accountDetail.address.PostalCode ?? '';

        return `${city ? city + ',' : city} ${zipCode}`;
    }
    return (
        <section className='c-form-section payment-account-info'>
            <div className='c-form-section__content'>
                <div className='title'>
                    <h6>
                        <span
                            className={`c-section-heading__title-text u-mr-xxsmall${
                                isQuoteDetail ? ' section-title' : ''
                            }`}
                        >
                            {payments.PAYMENT_INFORMATION_ACCOUNTINFOLABEL}
                        </span>
                        {isQuoteDetail ? null : (
                            <TooltipIcon
                                text={
                                    payments.PAYMENT_INFORMATION_ACCOUNTINFOTIP
                                }
                            ></TooltipIcon>
                        )}
                    </h6>
                </div>
                <div className='o-fieldset__row u-mt-large u-mb-large'>
                    <div className='o-layout'>
                        <div className='o-layout__item  u-1/2  u-1/1@l'>
                            <div className='field-show'>
                                <span className='label'>
                                    {
                                        payments.PAYMENT_INFORMATION_ACCOUNTNUMBERLABEL
                                    }
                                </span>
                                <span className='value'>
                                    {data.accountDetail.accountNumber}
                                </span>
                            </div>
                            <div className='field-show'>
                                <span className='label'>
                                    {
                                        payments.PAYMENT_INFORMATION_ACCOUNTTYPELABEL
                                    }
                                </span>
                                <span className='value'>
                                    {
                                        paymentAccountEnumToUi[
                                            data.accountDetail.accountType
                                        ]
                                    }
                                </span>
                            </div>
                            <div className='field-show'>
                                <span className='label'>
                                    {
                                        payments.PAYMENT_INFORMATION_VEHICLEIDLABEL
                                    }
                                </span>
                                <span className='value'>
                                    {data.accountDetail.vin}
                                </span>
                            </div>
                            {isQuoteDetail ? (
                                <>
                                    <div className='field-show'>
                                        <span className='label'>
                                            {payments.PAYMENTS_MAKE_LABEL}
                                        </span>
                                        <span className='value'>
                                            {data.accountDetail.vehicleMake}
                                        </span>
                                    </div>
                                    <div className='field-show'>
                                        <span className='label'>
                                            {payments.PAYMENTS_MODEL_LABEL}
                                        </span>
                                        <span className='value'>
                                            {data.accountDetail.vehicleModel}
                                        </span>
                                    </div>
                                </>
                            ) : (
                                <div className='field-show'>
                                    <span className='label'>
                                        {
                                            payments.PAYMENT_INFORMATION_VEHICLEDESCLABEL
                                        }
                                    </span>
                                    <span className='value'>
                                        {`${data.accountDetail.vehicleYear} ${data.accountDetail.vehicleMake} ${data.accountDetail.vehicleModel} ${data.accountDetail.bodyStyle}`}
                                    </span>
                                </div>
                            )}
                        </div>
                        <div className='o-layout__item  u-1/2  u-1/1@l'>
                            <div className='field-show'>
                                <span className='label'>
                                    {
                                        payments.PAYMENT_INFORMATION_CUSTOMERNAMELABEL
                                    }
                                </span>
                                <span className='value'>
                                    {data.accountDetail.customerName}
                                </span>
                            </div>
                            <div className='field-show'>
                                <span className='label'>
                                    {payments.PAYMENT_INFORMATION_ADDRESSLABEL}
                                </span>
                                <span className='value'>
                                    {data.accountDetail.address.AddressLine1}
                                </span>
                            </div>
                            <div className='field-show'>
                                <span className='label'>
                                    {payments.PAYMENT_INFORMATION_LOCATIONLABEL}
                                </span>
                                <span className='value'>{getCity(data)}</span>
                            </div>
                            <div className='field-show'>
                                <span className='label'>
                                    {payments.PAYMENT_INFORMATION_PROVINCELABEL}
                                </span>
                                <span className='value'>
                                    {data.accountDetail.address.StateOrProvince}
                                </span>
                            </div>
                            <div className='field-show'>
                                <span className='label'>
                                    {
                                        payments.PAYMENT_INFORMATION_DEALERNUMLABEL
                                    }
                                </span>
                                <span className='value'>
                                    {dealerDataInfo?.dealer.dealerName}
                                </span>
                            </div>
                        </div>
                        <div className='o-layout__item  u-1/2  u-1/1@l'></div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ViewInformation;
